import { adminScopeCountsSchema } from '@steado/admin-contract/scope-counts';
import { queryOptions } from '@tanstack/react-query';

import type { ApiClient } from '@/lib/api/client';

/**
 * Every scope pill's number, and the sidebar's badges, in one cached read.
 *
 * Fetched by the shell, so by the time a list screen mounts the answer is
 * usually already in the cache and its pills render with their counts on the
 * first frame. One query key for the whole console, deliberately: seven
 * screens asking seven questions of the same six tables would be six times the
 * work to show the same numbers.
 *
 * Kept fresher than the default because these are queue depths an operator
 * watches, but not so fresh that switching screens refetches them.
 */
export const SCOPE_COUNTS_STALE_MS = 60_000;

export function scopeCountsQueryOptions(api: ApiClient) {
  return queryOptions({
    queryKey: ['admin', 'scope-counts'],
    queryFn: () => api.request({ path: '/admin/scope-counts', schema: adminScopeCountsSchema }),
    staleTime: SCOPE_COUNTS_STALE_MS,
  });
}
